import React from 'react';
import { useMantineTheme, ChevronIcon } from '@mantine/core';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function Chevron(_a) {
  var _b = _a, { direction, style } = _b, others = __objRest(_b, ["direction", "style"]);
  const theme = useMantineTheme();
  return /* @__PURE__ */ React.createElement(ChevronIcon, __spreadProps(__spreadValues({}, others), {
    style: __spreadProps(__spreadValues({}, style), {
      transform: direction === "next" && theme.dir === "ltr" || direction === "previous" && theme.dir === "rtl" ? "rotate(270deg)" : "rotate(90deg)"
    })
  }));
}
Chevron.displayName = "@mantine/dates/Chevron";

export { Chevron };
//# sourceMappingURL=Chevron.js.map
